import React from 'react';
import { Link } from 'react-router-dom';

const MobileApp = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <h2>Mobile App Development</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-md-6 align-self-center">
        <div>
          <h4><b>We create apps that offer a ‘Wow’ 
              experience to users, the very first time they use it.</b></h4>
          <br />
          <p>We are an expert in providing scalable and high-quality iOS and Android apps. 
            Techarabiya turns your ideas into convenient, appealing and quick apps. We offer the finest range of apps inclusive of the premium quality desired by different brands &amp; compatible with Android, iOS and Windows.  <br /><br />
            We develop mobile apps that make your mobile strategy a success. Techarabiya has UX specialist, market analyst and people who are expert in creating both 
            cross-platform and native apps.   	
          </p>
          <br />
        </div>
      </div>
      <div className="col-sm-12 col-md-6">
        <img src="./img/service-mob.png" className="img-fluid service-image" />
      </div>
    </div>
  </div>
  <div>
    <hr />
  </div>
  <div className="container">
    <div className="text-center">
      <div className="col-12 hr-style">
        <br />
        <h2><b>Services We Offer</b></h2>
        <hr />
        <br />
      </div>
    </div>
  </div>
  {/*==========================
Services Section
    ============================*/}
  <section id="services">
    <div className="container">
      <div className="row mb-5">
        <div className="col-lg-6">
          <div className="box wow fadeInLeft">
            <div className="icon"><img className="icon" src="./img/strategy.png" /></div>
            <h4 className="title">Strategy</h4>
            <p className="description">We design strategy according to the need of the business after analyzing the scenario and opportunities. Brands get a productive strategy with Techarabiya. </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/smartphone.png" /></div>
            <h4 className="title">UI &amp; UX App Designing</h4>
            <p className="description">We are proud to present exclusive UX &amp; UI services. Our developers and designers establish plans that create satisfy every demand.</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInLeft" data-wow-delay="0.2s">
            <div className="icon"><img className="icon" src="./img/app.png" /></div>
            <h4 className="title">App Development</h4>
            <p className="description">At Techarabiya, we do every job with utmost dedication and hard work. Techarabiya is known for developing great apps for various platforms e.g. iPhone, Android, Wearable devices etc.</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight" data-wow-delay="0.2s">
            <div className="icon"><img className="icon" src="./img/digital-marketing.png" /></div>
            <h4 className="title">App Marketing</h4>
            <p className="description">We do not just develop an app, we market it for you in order to get discovered anywhere. </p>
          </div>
        </div>
      </div>
    </div>
  </section>{/* #services */}
  {/*- Contact Us bar */}
  <div className="container contactus">
  <div className="row mb-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>
        
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
</div>

        </div>
    )
}

export default MobileApp
